import {
  useEffect,
  useState
} from 'react'
import {
  Box,
  Button
} from '@chakra-ui/react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  AnimatePresence,
  motion
} from 'framer-motion'
import {
  setOpenBlogLink,
  usersSelectors
} from 'store'
import { CloseIconTransparent } from 'assets/icons'
import { isMobile } from 'utils/helpers'

const MotionBox = motion(Box)

export const BlogVideoModal = () => {
  const dispatch = useDispatch()
  const [isLandscape, setIsLandscape] = useState(false)

  const [isWiden, setIsWiden] = useState(false)
  const headerHeight = document.querySelector('.header')?.offsetHeight
  const footerHeight = document.querySelector('.notificationBar')?.offsetHeight
  const mobileLandscape = isLandscape && isMobile()

  const { openBlogLink } = useSelector(usersSelectors)

  const handleClose = () => {
    setIsWiden(false)
    dispatch(setOpenBlogLink(''))
  }

  const handleWiden = () => {
    if (isMobile()) {
      return isWiden
        ? 'calc(100svh - 100px)'
        : 'min(450px, 100vw)'
    }

    return isWiden
      ? 'min(100vw, calc((100vh - 103px) * 16 / 9))'
      : 'min(650px, 100vw)'
  }

  const handleHeight = () => {
    if (isMobile()) {
      return isWiden
        ? 'min(88svw, calc(100svw * 16 / 9))'
        : 'min(265px, calc(100svw * 9 / 16), calc(100svh - 100px))'
    }

    return isWiden
      ? 'min(calc(100vw * 9 / 16), calc(100vh - 100px))'
      : 'calc(min(650px, 100vw) * 9 / 16)'
  }

  useEffect(() => {
    if (mobileLandscape) {
      setIsWiden(false)
    }
  }, [isLandscape])

  useEffect(() => {
    const onResize = () => {
      const landscape = window.matchMedia('(orientation: landscape)').matches
      setIsLandscape(landscape)
    }

    window.addEventListener('resize', onResize)
    onResize()

    return () => window.removeEventListener('resize', onResize)
  }, [])

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!openBlogLink) return
      if (e.key === 'Escape') {
        e.stopPropagation()
        handleClose()
      }
    }

    window.addEventListener('keydown', handleKeyDown, true)
    return () => window.removeEventListener('keydown', handleKeyDown, true)
  }, [openBlogLink])

  return (
    <AnimatePresence>
      {
        openBlogLink
          ? (
            <MotionBox
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              position="fixed"
              top={0}
              left={0}
              width="100%"
              height="100%"
              zIndex="9998"
              alignItems="center"
              justifyContent="center"
              display="flex"
              onClick={() => handleClose()}
            >
              <Box onClick={(e) => e.stopPropagation()}>
                <Box
                  width="100%"
                  position="fixed"
                  backdropFilter="blur(4px)"
                  background="rgba(250, 250, 250, 0.4)"
                  left={0}
                  top={`${headerHeight}px`}
                  height={`calc(100svh - ${headerHeight}px - ${footerHeight}px)`}
                  onClick={() => handleClose()}
                />

                <Box
                  position="fixed"
                  top="50%"
                  left="50%"
                  transform={`translate(-50%, -50%) ${isMobile() && isWiden ? 'rotate(90deg)' : ''}`}
                  background="white"
                  borderRadius="5px"
                  width={handleWiden()}
                  transition="0.8s ease"
                  maxHeight="calc(100vh - 100px)"
                  boxShadow={false}
                  overflow="visible"
                >
                  <Button
                    backgroundColor="transparent"
                    zIndex="30"
                    borderRadius="full"
                    position="absolute"
                    right="6px"
                    top="6px"
                    width="20px"
                    height="20px"
                    padding="0"
                    minWidth="0"
                    boxShadow="0 4px 10px rgba(0, 0, 0, 0.2)"
                    onClick={() => handleClose()}
                    filter="drop-shadow(0 2px 4px rgba(0,0,0,0.6))"
                  >
                    <CloseIconTransparent />
                  </Button>

                  <Box
                    padding="3.5px"
                    display="flex"
                    justifyContent="center"
                    transition="0.8s ease"
                    height={handleHeight()}
                  >
                    <Box
                      position="relative"
                      transition="0.8s ease"
                      width="min(calc((100vh - 107px) * 16 / 9), 100%)"
                      overflow="hidden"
                      borderRadius="5px"
                      aspectRatio={16 / 9}
                    >
                      <iframe
                        id="odysee-iframe"
                        title="videoNotification"
                        width="100%"
                        height="100%"
                        src={openBlogLink}
                        style={{
                          borderRadius: '5px',
                          border: 0
                        }}
                        allowFullScreen
                        allow="autoplay"
                      />

                      <Button
                        position="absolute"
                        bottom="0"
                        right="0"
                        zIndex="40"
                        background="transparent"
                        borderRadius="0"
                        width={openBlogLink.includes('youtube') ? '55px' : '45px'}
                        height={openBlogLink.includes('youtube') ? '39px' : '43px'}
                        padding="0"
                        cursor="pointer"
                        onClick={() => {
                          if (!mobileLandscape) {
                            setIsWiden(!isWiden)
                          }
                        }}
                        backdropFilter={mobileLandscape ? 'blur(4px)' : ''}
                        _hover={false}
                        _active={false}
                        _focusVisible={false}
                        _focus={false}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </MotionBox>
          ) : ''
      }
    </AnimatePresence>
  )
}
